import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

const list = articles.slice(1, 7);

export default function FeaturedSection() {
  return (
    <section id="on-site" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          kicker="ON-SITE"
          title="现场直击"
          desc="以事件当天的时间线为骨架，记录正在发生的第一手实况与目击者描述。"
          action={{ label: "查看全部", to: "/live" }}
        />
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}